import { VIEW_MANAGEMENT } from 'store/types';

function manageNotificationsDialog() {
  return {
    type: VIEW_MANAGEMENT.MANAGE_NOTIFICATION_DIALOG,
  };
}

export default manageNotificationsDialog;
